module.exports = __webpack_public_path__ + "static/media/loading.fe58e18f.png";